<template>
  <div v-if="ispaid">
    <div class="br-learn-more" v-if="cdSpecialButton">
      <button
        type="button"
        data-name="quote"
        :data-clicktype="featuredTest ? '87' : '11'"
        data-eventtype="click"
        data-track-click="ratetable.revenueclick"
        class="button --action --inverted --spaceless +pd-left-xs +pd-right-xxs"
        @click="trackParent()"
        :id="`br-lender-learn-more-${index}-button`"
      >
        Open Account
        <svg
          class="button__icon"
          style="width: 1rem;"
          width="1792"
          height="1792"
          viewBox="0 0 1792 1792"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1363 877l-742 742q-19 19-45 19t-45-19l-166-166q-19-19-19-45t19-45l531-531-531-531q-19-19-19-45t19-45l166-166q19-19 45-19t45 19l742 742q19 19 19 45t-19 45z"
          />
        </svg>
      </button>
    </div>

    <a
      v-else
      href="#"
      data-name="quote"
      :data-clicktype="featuredTest ? '87' : '11'"
      data-eventtype="click"
      data-track-click="ratetable.revenueclick"
      @click="trackParent()"
      :class="
        `button ${buttonWidth} --action br-next-button track +mg-bottom-xs`
      "
      :id="`br-lender-learn-more-${index}-button`"
    >
      {{ callToAction }}
      <svg
        v-if="hasarrow"
        class="button__icon --dark +display-none +display-inline-block--md"
        width="24px"
        height="13px"
        viewBox="0 0 30 13"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <path
          d="M28,6.33492073 L28.1913673,6.14505595 L28.1913673,6.85494405 L28,6.66507927 L28,6.33492073 Z M27.3296576,7 L22.6478428,11.6450559 L23.3521572,12.3549441 L28.8956818,6.85494405 L29.2534347,6.5 L28.8956818,6.14505595 L23.3521572,0.645055948 L22.6478428,1.35494405 L27.3296576,6 L0,6 L0,7 L27.3296576,7 Z"
          id="Combined-Shape"
        ></path>
      </svg>
    </a>
    <div v-if="phone">
      <div
        class="rate-table__row-copy --dark-gray br-cpc-text size-full--xs --telephone"
      >
        {{ phone | phoneFormat }}
      </div>
      <div class="rate-table__row-copy --small --toll-free">
        Toll-free, no obligation
      </div>
    </div>
  </div>
</template>

<script>
import parentTracking from 'apps/utility/parentTracking'

// @DEPRECATED - Rewrite or clean up for any future use
export default {
  mixins: [parentTracking],
  props: {
    cdSpecialButton: {
      type: Boolean,
      default: false
    },
    callToAction: {
      type: String,
      default: 'Next'
    },
    ispaid: {
      default: ''
    },

    cpc: {
      default: ''
    },

    phone: {
      default: ''
    },

    index: {
      default: ''
    },

    hasarrow: {
      default: () => {
        return {}
      }
    },

    row: {
      default: ''
    },

    buttonWidth: {
      type: String,
      default: '--small'
    },
    featuredTest: {
      type: Boolean,
      default: false
    }
  }
}
</script>
